import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SuperAdminLanding = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/super_admin/login');
  }, [navigate]);

  return null; // No need to render anything since it redirects immediately
};

export default SuperAdminLanding;
